export default function getErrorMessage(error) {
  return error.response?.data?.error ?? error?.response?.data ?? error.message ?? 'Something went wrong';
}
